/**
 * MCP system prompt surface — exposes the user-authored AI agent system
 * prompt (Settings → AI Agent Prompt) to the hub agent over the bridge.
 */

import { useSystemPromptStore } from '../../state/useSystemPromptStore';
import { compileSystemPrompt } from '../../utils/systemPrompt';
import { okJson } from './mcpResultUtils';
import type { McpToolHandler } from './mcpResultUtils';

export const handleGetSystemPrompt: McpToolHandler = () => {
    const { enabled, categories } = useSystemPromptStore.getState();
    const compiled = compileSystemPrompt(enabled, categories);
    return okJson(
        {
            enabled: compiled.enabled,
            prompt: compiled.prompt,
            sections: categories.map((c) => ({ id: c.id, title: c.title, enabled: c.enabled })),
        },
        // Text carries the instruction body itself (empty when inactive) so the
        // hub agent can adopt it directly without JSON parsing.
        compiled.prompt
    );
};
